import * as React from "react";
import { Callout } from "@fluentui/react/lib/Callout";
import { Stack, IStackTokens, IStackStyles } from "@fluentui/react/lib/Stack";
import { FontIcon } from "@fluentui/react";
import { colors } from "constants/constants";
import useId from "@mui/material/utils/useId";

const stackTokens: IStackTokens = {
	childrenGap: 4,
	// maxWidth: 300,
};

const labelCalloutStackStyles: Partial<IStackStyles> = {
	root: { marginLeft: 15, marginRight:15 },
};
// interface IProps {
// 	desc: string;
// }
export const Tooltip = ({ desc}): JSX.Element => {
	
	const [isCalloutVisible, toggleIsCalloutVisible] = React.useState(false);

	const descriptionId: string = useId("description");
	const iconButtonId: string = useId("iconButton");
	return (
		<>
			<Stack
				horizontal
				verticalAlign="center"
				tokens={stackTokens}
				
			>
				<FontIcon
					style={{
						cursor: "pointer",
						marginLeft: 10,
						marginTop:-7,
						color: colors.primaryBlue,
					}}
					color={colors.primaryBlue}
					id={iconButtonId}
					iconName="Info"
					onMouseEnter={() => toggleIsCalloutVisible(true)}
					onMouseLeave={() => toggleIsCalloutVisible(false)}
				/>
				
			</Stack>
			{isCalloutVisible && (
				<Callout
					target={"#" + iconButtonId}
					setInitialFocus
					onDismiss={() => toggleIsCalloutVisible(false)}
					ariaDescribedBy={descriptionId}
					role="alertdialog"
					className="tooltip"
				>
					<Stack
						tokens={stackTokens}
						horizontalAlign="start"
						styles={labelCalloutStackStyles}
						
					>
						<p>{desc }</p>
					</Stack>
				</Callout>
			)}
		</>
	);
};